import DOMPurify, { sanitize, isSupported } from 'isomorphic-dompurify'

export function filterDirtyHTML(dirtyHTML) {
	return isSupported ? sanitize(dirtyHTML, { FORBID_ATTR: ['src'] }) : dirtyHTML
}

export function dirtyHTML(str) {
	return DOMPurify.sanitize(str)
}
